import React, { useEffect } from "react";
import { Box, makeStyles, TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { useDispatch, useSelector } from "react-redux";
import { actionTypes } from "../../../../../../../redux/bourse/subCategory";


let useStyles = makeStyles((theme) => ({
    root: {
        width:"250px",
        [theme.breakpoints.down("700")]: {
            width: '100%',
        },
    },
    box: {
        margin: 10,
        [theme.breakpoints.down("700")]: {
            margin: '10px 0px',
            width: '100%',
        },
    }
}))

export default function Index({ handleChange, state, setState }) {

    let classes = useStyles();
    let dispatch = useDispatch();

    const stateReducer = useSelector((state) => state.bourse_select_subCategory_reducer);


    const apiSubmit = () => {

        let data = {
            main_category: state?.['main_category']?.code,
            sub_category: state?.['category']?.code,
        };
        dispatch({
            type: actionTypes.selectSubCategortyBourseAsync,
            payload: {
                data: data
            },
        });
    };

    useEffect(() => {
        if (state['category']) {
            apiSubmit()
        }
    }, [state['category']]);


    useEffect(() => {

        if (stateReducer?.data?.length) {

            setState((prev) => ({
                ...prev,
                sub_category: null,
            }))

            dispatch({
                type: actionTypes.selectSubCategortyBourseEmpty,
            });
        }

    }, [state['category']]);


    return (
        <div className={classes['root']}>
            <Box
                className={classes['box']}
                // marginBottom="30px"
                width="250px"
                height="40px"
            >
                <Autocomplete
                    size={"small"}
                    id="combo-box-demo2"
                    disabled={(stateReducer.data && state?.['category']) ? false : true}
                    options={stateReducer?.data}
                    getOptionLabel={(option) => option?.name}
                    value={state?.['sub_category'] ? state?.['sub_category'] : null}
                    onChange={(event, value) => handleChange(value, "sub_category")}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label="همه زیر گروه ها"
                            variant="outlined"
                        />
                    )}
                />
            </Box>
        </div>)
}
